import { dataPlusCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlusCircleSolid = /*#__PURE__*/createIcon(dataPlusCircleSolid)
export default IconPlusCircleSolid
